"use client"

import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import HeroMyAccount from '@/components/Hero/HeroMyAccount';
import OrderDetails from '@/components/MyAccount/OrderDetails/OrderDetails';
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";

import { useRouter } from 'next/navigation';
// import OrdersSummary from '@/components/MyAccount/OrderSummary/OrderSummary';
import seoData from '@/data/seo.json';
import config from "../../../../config.mjs";


export default function MyAccount() {

    const router = useRouter();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { apiBaseUrl } = config
    const getOrderData = async function (token) {
        try {
            const response = await fetch(apiBaseUrl + '/user/orders', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                return await response.json();
            }
        } catch (error) {
            console.log(`Error: ${error}`);

        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const session = sessionStorage.getItem('sessionToken');

            if (!session) {
                router.push('/log-in');
            } else {
                try {
                    const data = await getOrderData(session);
                    setUserData(data.orders);


                } catch (error) {
                    console.error('Failed to fetch order data:', error);
                } finally {
                    setLoading(false);


                }
            }
        };

        fetchData();
    }, [router]);




    const seo = seoData['account']
    return (
        <>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
            </Helmet>
            <main>
                <Header />
                <HeroMyAccount />
                <div className="max-w-[762px] mx-auto  md:pt-10 pt-6 pb-10 md:pb-28 flex flex-col gap-14">

                    {loading ? (
                        <div className="flex justify-center items-center py-20">
                            <div className="w-16 h-16 border-4 border-orange border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    ) : (
                        userData && userData.map((order) => (
                            <React.Fragment key={order.orderNumber}>
                                <OrderDetails

                                    order={order}
                                />
                            </React.Fragment>
                        ))
                    )}
                </div>
                <Footer />
            </main>
        </>
    );
}